import React from "react";
import { Button, Modal } from "react-bootstrap";
import { FiAlertCircle, FiCheckCircle, FiInfo } from "react-icons/fi";

const icones = {
    danger: FiAlertCircle,
    success: FiCheckCircle,
    info: FiInfo,
}

export default function Message({ message, onClose }) {
    const variant = message?.variant || 'info'
    const Icone = icones[variant] || icones.info

    return (
        <Modal show={!!message} onHide={onClose} centered className="message-modal">
            <Modal.Header closeButton>
                <Modal.Title className={`message-modal__title message-modal__title--${variant}`}>
                    <Icone /> {message?.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="message-modal__body">
                {message?.body}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onClose}>J'ai compris</Button>
            </Modal.Footer>
        </Modal>
    )
}
